import { render, staticRenderFns } from "./HistoricoCertificacao.vue?vue&type=template&id=2340efd8&scoped=true"
import script from "./HistoricoCertificacao.vue?vue&type=script&lang=js"
export * from "./HistoricoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCertificacao.vue?vue&type=style&index=0&id=2340efd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340efd8",
  null
  
)

export default component.exports